<!-- About Us Top Text -->
<section id="about-us">
  <div class="container text-center">
    <h2>Welcome to Wholesale Flights</h2>
    <p>Wholesale Flights is a boutique travel agency specializing in business and first class airfare. We thrive on
      building personal long-term relationships with our clients to provide the ultimate in customer service and
      respect. Our primary goal is to earn customer loyalty and trust by providing deeply discounted fares and
      an incredibly honest and reliable service. Our advantage is that we have negotiated contracts with major
      consolidators and wholesalers which enables us to offer deep discounts which are not available directly through
      the airlines or other travel websites.</p>
  </div>
</section>

<!-- Corporate Info Block -->
<section id="corporate-info">
  <div class="container">
    <div class="col-sm-12 text-center">
      <h2 class="mt-4">Save 30-70% off business class flights</h2>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-4">
        <div class="text-center counter">
          <h6>40+</h6>
          <p>Travel experts</p>
        </div>
      </div>
      <div class="col-sm-12 col-md-4">
        <div class="text-center counter">
          <h6>10,000,000+</h6>
          <p>Over $10 million saved since 2006</p>
        </div>
      </div>
      <div class="col-sm-12 col-md-4">
        <div class="text-center counter">
          <h6>36%</h6>
          <p>Average discount per flight</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Page Content Service Block-->
<app-service></app-service>

<!-- FAQ Block -->
<section id="faq">
  <div class="container">
    <div class="col-sm-12 text-center">
      <h2 class="mt-4">Frequently Asked Questions</h2>
    </div>
    <div class="container">
      <div class="col-md-12 col-sm-12">
        <div class="panel-group wrap">
          <section *ngFor="let faq of faqData;">
            <app-faq [question]="faq.question"
                     [answer]="faq.answer"
                     [id]="faq.id"></app-faq>
          </section>
        </div>
      </div>
    </div>
  </div>
</section>

